import { render, staticRenderFns } from "./CheckplusSuccess.vue?vue&type=template&id=34bde9c2&"
import script from "./CheckplusSuccess.vue?vue&type=script&lang=js&"
export * from "./CheckplusSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports